import * as mutationTypes from "@/store/mutation-types";
import rol from "@/config/rol-values";

export const state = {
    dataLogin: {},
    sessionTime: 0,
    user: {},
    editCompanyInfo: {
        companyId: null,
        companyName: null
    }
};

export const mutations = {
    [mutationTypes.SET_LOGIN]: (state, payload) => {
        state.dataLogin = payload
    },
    [mutationTypes.SET_SESSION_TIME]: (state, payload) => {
        state.sessionTime = payload
    },
    [mutationTypes.SET_USER]: (state, payload) => {
        state.user = payload
    },
    [mutationTypes.SET_EDIT_COMPANY_INFO]: (state, payload) => {
        state.editCompanyInfo = payload
    },
};

export const actions = {
    setDataLogin({commit}, payload) {
        commit(mutationTypes.SET_LOGIN, payload)
        return true
    },
    setSessionTime({commit, state}) {
        commit(mutationTypes.SET_SESSION_TIME, Date.now() + state.dataLogin.sessionExpiration*1000)
    },
    setUser({commit}, payload = {}) {
        commit(mutationTypes.SET_USER, payload || userMock);
    },
    setEditCompanyInfoUser({commit}, payload = {}) {
        commit(mutationTypes.SET_EDIT_COMPANY_INFO, {});
        commit(mutationTypes.SET_EDIT_COMPANY_INFO, payload);
    },
    setLogout({commit}) {
        localStorage.clear()
        commit(mutationTypes.SET_LOGIN, {})
        commit(mutationTypes.SET_SESSION_TIME, 0)
        commit(mutationTypes.SET_USER, {})
        commit(mutationTypes.SET_EDIT_COMPANY_INFO, {})
    }
};

export const getters = {
    getDataLogin: state => state.dataLogin,
    getSessionExpirationd: state => state.dataLogin.sessionExpiration,
    getTypeAuth: state => state.dataLogin.typeAuth,
    getToken: state => state.dataLogin.token,
    // //
    getUser: state => state.user,
    getUserCompanyInfo: state => state.user.companyInfo,
    getCompanyId: state => state.user.companyInfo?.companyId,
    getCompanyName: state => state.user.companyInfo?.companyName,
    getCompanyPath: state => state.user.companyInfo?.companyPath,
    getOfficesByCompanyInfo: state => state.user.companyInfo?.offices,
    getEditCompanyInfo: state => state.editCompanyInfo,
    getEditCompanyInfoId: state => state.editCompanyInfo?.companyId,
    getEditCompanyInfoName: state => state.editCompanyInfo?.companyName,
    getEditOfficesByCompanyInfoId: state => state.editCompanyInfo?.companyOffices,
    isSiteAdminOrUser: state => [rol.SITE_USER, rol.SITE_ADMIN, rol.DISPLAY_USER].includes(state.user.role?.roleId),
    getUserEmail: state => state.user.email.replace(/['"]+/g, ''),
    getUserFeatures: state => state.user.features,
    getUserName: state => state.user.firstName,
    getUserLastName: state => state.user.lastName,
    getUserLastAccess: state => state.user.lastAccess,
    getUserPasswordExpiration: state => state.user.passwordExpiration,
    getPreviousAccessDateTime: state => state.user.previousAccess,
    getRoleId: state => state.user?.role?.roleId,
    getRoleName: state => state.user.role.roleName,
    getUserId: state => state.user.userId,
    getUserLogin: state => state.user.userLogin,
    // //
    getSessionTime: state => state.sessionTime,
    // //
    getMainView: state => [rol.SITE_USER, rol.SITE_ADMIN].includes(state.user.role?.roleId) ? "dashboardCalidadServicio" :  
    rol.DISPLAY_USER===state.user.role?.roleId ? "dashboardTiempoReal" : "adminCompanies"


};

export default {
    state,
    getters,
    mutations,
    actions
};

const userMock = {
    "companyId": 1,
    "lasAccessDateTime": "2022-08-09T11:02:50.295Z",
    "lasActionDateTime": "2022-08-09T11:02:50.295Z",
    "numLoginRetries": 0,
    "passwordChangeMandatory": 0,
    "passwordExpirationDateTime": "2022-08-09T11:02:50.295Z",
    "passwordResetToken": "string",
    "previousAccessDatetime": "2022-08-09T11:02:50.295Z",
    "roleId": 1,
    "userCreationDate": "2022-08-09T11:02:50.295Z",
    "userEmail": "email@prueba_1.com",
    "userId": 1,
    "userLocked": 0,
    "userLogin": "user_login_1",
    "userName": "user_name_1",
    "userPassword": "user_password_1",
    "userSession": "user_session_1"
}

